let already_shown = false;
let should_trigger_mobile = false;
let timer,
  scrollDelta = 0,
  scrollLastPos = null;
const speed_sensitivity = 70;


export default {

  data() {
    return {
      leave_modal_visible: false,
      leave_modal_mute: false,
    };
  },


  created() {
    if (this.leave_modal_enabled) {
      this.leave_modal_init();
    }
  },


  computed: {

    leave_modal_enabled() {
      return +js_query_params.exit === 1 || this.$root.js_data.is_exit_popup === 1;
    },

  },


  methods: {

    leave_modal_init() {
      const timeout = 5000 + (this.preloader_enabled ? 10000 : 0);

      // skip if coupon already applied
      if (window.location.href.includes('coupon=10off')) {
        return;
      }

      // navigate to empty hash and start tracking change
      setTimeout(() => {
        window.location.href = "#";
      }, 1000);
      window.addEventListener("hashchange", (e) => {
        if (e.oldURL.length > e.newURL.length && !this.isShown && !already_shown) {
          this.leave_modal_show();
          e.preventDefault();
        }
      });

      setTimeout(() => {
        document.addEventListener('mouseleave', () => {
          if (!already_shown && !this.is_submitted && !this.leave_modal_mute && !localStorage.getItem('leave_modal_mute')) {
            this.leave_modal_show();
          }
        });
      }, timeout);

      // mobile popup
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          document.addEventListener("scroll", this.leave_modal_scroll);
        }, 20 * 1000); // delay 30 before applying mobile popup rules
      }
    },

    leave_modal_show() {
      this.leave_modal_visible = true;
      already_shown = true;
    },

    leave_modal_agree_click() {
      window.location = window.location.href.split("#")[0] + (window.location.href.includes("?") ? "&" : "?") + "coupon=10off";
      this.leave_modal_visible = false;
      this.scroll_to_ref('content');

      // save user form
      if (this.form) {
        const formData = JSON.stringify(
          Object.keys(this.form).map(key => {
            return { name: key, value: this.form[key] };
          })
        );
        localStorage.setItem('saved_form', formData);
      }
    },

    leave_modal_close_click() {
      this.leave_modal_visible = false;
    },

    leave_modal_scroll(event) {
      if (!should_trigger_mobile && window.scrollY > document.documentElement.scrollHeight * 0.3) {
        should_trigger_mobile = true;
      }

      // record scroll speed
      const newPos = window.scrollY;
      if (scrollLastPos != null) {
        scrollDelta = newPos - scrollLastPos;
      }
      scrollLastPos = newPos;
      clearTimeout(timer);
      timer = setTimeout(() => {
        scrollLastPos = null;
        scrollDelta = 0;
      }, 50);

      // scrolled more than 30% document than scrolled fast up - show popup
      if (!already_shown && should_trigger_mobile && scrollDelta < -speed_sensitivity && !localStorage.getItem('leave_modal_mute')) {
        this.leave_modal_show();
      }
    },

  },

};
